"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgPlusLightIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 26 26', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', d: 'M14.024 4.46c0-.594-.478-1.072-1.072-1.072s-1.071.478-1.071 1.072v7.857H4.024c-.594 0-1.072.477-1.072 1.071s.478 1.072 1.072 1.072h7.857v7.857c0 .594.477 1.071 1.071 1.071s1.072-.477 1.072-1.071V14.46h7.857c.593 0 1.071-.478 1.071-1.072s-.478-1.071-1.071-1.071h-7.857z' }) })));
});
exports.default = (0, react_1.memo)(SvgPlusLightIcon);
